import { render, staticRenderFns } from "./DingDingTip.vue?vue&type=template&id=6689971c&scoped=true"
import script from "./DingDingTip.vue?vue&type=script&lang=js"
export * from "./DingDingTip.vue?vue&type=script&lang=js"
import style0 from "./DingDingTip.vue?vue&type=style&index=0&id=6689971c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6689971c",
  null
  
)

export default component.exports